import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container-max section-padding">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <Logo className="h-12 mb-4" showText={true} textSize="text-2xl" />
            <p className="text-gray-300 mb-4 max-w-md">
              Revolutionizing QA automation with cutting-edge testing solutions. 
              We accelerate development cycles, automate testing processes, and 
              dominate quality assurance across all domains.
            </p>
            <div className="flex items-center space-x-2">
              <span className="text-accent-500 font-semibold">Accelerate</span>
              <span className="text-gray-400">•</span>
              <span className="text-accent-500 font-semibold">Automate</span>
              <span className="text-gray-400">•</span>
              <span className="text-accent-500 font-semibold">Dominate</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-primary-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-primary-400 transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-primary-400 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-primary-400 transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li>
                <span className="text-gray-300">API Testing</span>
              </li>
              <li>
                <span className="text-gray-300">UI Testing</span>
                <span className="text-xs text-accent-500 ml-2">Coming Soon</span>
              </li>
              <li>
                <span className="text-gray-300">Performance Testing</span>
                <span className="text-xs text-accent-500 ml-2">Coming Soon</span>
              </li>
              <li>
                <span className="text-gray-300">Security Testing</span>
                <span className="text-xs text-accent-500 ml-2">Coming Soon</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm">
              © 2025 EJBED. All rights reserved. Testing Tomorrow, Today.
            </div>
            <div className="flex items-center space-x-6 mt-4 md:mt-0">
              <a
                href="mailto:info@ejbed.com"
                className="text-gray-400 hover:text-primary-400 transition-colors text-sm"
              >
                info@ejbed.com
              </a>
              <a
                href="https://ejbed.com/app/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary-400 transition-colors text-sm flex items-center space-x-1"
              >
                <span>Launch App</span>
                <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 